// extracted by mini-css-extract-plugin
module.exports = {"SliderContainer":"Slider_SliderContainer__25L5_","Image":"Slider_Image__1js4a"};